<template>
  <div>
    <template v-if="hasEmployeursAdmissibles">
      <data-iterator
        :list="emploisReferencesAdmissibles"
        add-new-text=""
        :icon="$getIcon('job')"
        card-width="700"
        optional
        :valids="valids"
        ref="dataIterator"
        hideDots
        hideAdd
        hideDelete
        :opq-if="emploisReferencesAdmissibles.length > 0"
      >
        <template v-slot:show-mode="{ item }">
          <div class="d-flex align-center">            
            <opq-case              
              no-label
              v-model="item.serviceDeReferenceActif"
              :disabled="item.inactif"
              :live="liveSasEmploiReference(item, 25208)"
              optional
              :ref="'serviceDeReference-' + item.id"
              @eudo-updated="serviceReferenceCoche(item)"
            ></opq-case>
            <div class="ml-3">
              <ressource v-show="item.inactif" code="message-bureau-enregistre"></ressource>
              <h3>{{ getEmployeurByEmploiReference(item).raisonSociale }}</h3>
              <p class="my-0">{{ getEmployeurByEmploiReference(item).adresse }}</p>
              <p class="my-0">{{ getEmployeurByEmploiReference(item).ville }}</p>
            </div>
          </div>
          <div class="ml-12">
            <opq-case
             :opq-if="item.serviceDeReferenceActif && !item.inactif"
              code="service-reference-suspension"
              v-model="item.suspendreEmploiReference"
              :live="liveSasEmploiReference(item, 25210)"
              optional
            ></opq-case>
            <opq-catalogue
              :opq-if="item.suspendreEmploiReference"
              code="service-reference-suspension-motif"
              v-model="item.motifDeSuspension"
              :live="liveSasEmploiReference(item, 25212)"
              :optional="!item.suspendreEmploiReference"
              :filter="filtreMotifSuspension"
              order-by="text"
            ></opq-catalogue>
          </div>
        </template>
        <template v-slot:edit-mode="{ item }">
          <div class="mt-4">
            <ressource code="information-services-offerts"></ressource>
          </div>
          <div>
            <ressource code="information-modalite-intervention"></ressource>
          </div>
          <opq-catalogue
            code="service-reference-modalite-intervention"
            v-model="item.modalitesDIntervention"
            :live="liveSasEmploiReference(item, 25203)"
            optional
            order-by="text"
          ></opq-catalogue>
          <opq-text-field
            code="service-reference-modalite-autre"
            v-model="item.autresModalitesDIntervention"
            :live="liveSasEmploiReference(item, 25204)"
            optional
          ></opq-text-field>
          <div>
            <ressource code="service-reference-disponibilite"></ressource>
          </div>
          <opq-catalogue
            code="service-reference-disponibilite-emploi"
            v-model="item.disponibilitePourRecevoirDeNouveauxClients"
            :live="liveSasEmploiReference(item, 25206)"
            :optional="!item.serviceDeReferenceActif"
          ></opq-catalogue>
          <opq-catalogue
            code="service-reference-clients"
            v-model="item.recevoirDeNouveauxClients"
            :live="liveSasEmploiReference(item, 25207)"
            :optional="!item.serviceDeReferenceActif"
          ></opq-catalogue>
        </template>
      </data-iterator>
    </template>
  </div>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"

export default {
  mixins: [CataloguesHelper],
  props: {
    sas: { type: Object, required: true },
    valids: { type: Array, default: () => [] }
  },
  methods: {
    liveSasEmploiReference(item, cle) {
      return { endpoint: "sas-emplois-references", cle: cle, fileId: item.id }
    },
    filtreMotifSuspension(fd) {
      return fd.code.includes("web")
    },
    estTypeEmploi(item, type) {
      return this.getCatalogueCodeById(2902, item.typeDEmploi) == type
    },

    getEmployeurByEmploiReference(emploiReference) {
      return this.sas.employeurs.find((e) => e.id === emploiReference.sasCartesDAffaires)
    },
    /**
     * Gère le cochage/décochage du service de référence
     * Le sasEmploiReference existe déjà (créé à l'init), on ne fait que forcer le rafraîchissement
     */
    async serviceReferenceCoche(sasEmploiReference) {
      // Forcer le rafraîchissement de la vue pour afficher/masquer les champs
      this.$forceUpdate()
      // Émettre un événement pour informer le parent
      this.$emit("service-reference-changed", sasEmploiReference)
    },
  },
  computed: {
    /**
     * Retourne les employeurs admissibles pour le service de référence
     * (type privé, non inactif)
     */
    employeursAdmissibles() {
      return (
        this.sas?.employeurs?.filter((e) => this.estTypeEmploi(e, "Pri") && !e.inactif) ?? []
      )
    },
    hasEmployeursAdmissibles() {
      return this.employeursAdmissibles.length > 0
    },
    /**
     * Liste des emplois références admissibles à afficher dans le data-iterator
     */
    emploisReferencesAdmissibles() {
      return this.sas?.emploisReferences?.filter((e) => this.employeursAdmissibles.map((emp) => emp.id).includes(e.sasCartesDAffaires)) ??
        []
    },
  },
}
</script>

<style scoped></style>
